import ChangePasscodeForm from "../../components/views/change-passcode/change-passcode";

function ChangePasscodePage() {
  return <ChangePasscodeForm />;
}

export default ChangePasscodePage;
